const ufeApi = require('services/api/ufeApi');
const { userXTimestampHeader } = require('utils/Headers');
const locationUtils = require('utils/Location');

function acknowledgeGameCompletion(token, { gameId, loyaltyId }) {
    const sdnApiHost = Sephora.configurationSettings.sdnApiHost;
    const params = locationUtils.isPreviewEnvironment() ? '?isPreview=true' : '';
    const url = `${sdnApiHost}/v1/game/${gameId}/user/${loyaltyId}/completion/acknowledge${params}`;
    const timeStamp = userXTimestampHeader()['x-timestamp'];

    return ufeApi
        .makeRequest(url, {
            method: 'PUT',
            headers: {
                'x-source': 'rwd',
                'X-Request-Timestamp': timeStamp,
                authorization: `Bearer ${token}`
            }
        })
        .then(data => data);
}

module.exports = { acknowledgeGameCompletion };
